import Button from "./Button";
import CheckBox from "./CheckBox";
import DatePicker from "./DatePicker";
import Password from "./Input/Password";
import Phone from "./Input/Phone";
import Email from "./Input/Email";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import TextInput from "./TextInput";
import AutoComplete from "./AutoComplete";
import InlineSelect from "./InlineSelect";
import Price from "./Input/Price";
import Switch from "./Switch";

const FormFields = {
  TextInput,
  RadioGroup,
  Select,
  InlineSelect,
  AutoComplete,
  CheckBox,
  Switch,
  DatePicker,
  Button,
  Password,
  Phone,
  Email,
  Price,
};

export default FormFields;
